import StoreHomePage from './pages/StoreHomePage.vue';
import BoutiquePage from './pages/BoutiquePage.vue';
import ProductDetailPage from './pages/ProductDetailPage.vue';

const routes = [
  {
    path: '/',
    name: 'store-home',
    component: StoreHomePage,
    meta: {
      title: 'Kingrecharges Store - Abonnements & Cartes Cadeaux',
    }
  },
  {
    path: '/boutique',
    name: 'store-boutique',
    component: BoutiquePage,
    meta: {
      title: 'Boutique - Kingrecharges Store',
    }
  },
  {
    path: '/produit/:id',
    name: 'store-product',
    component: ProductDetailPage,
    meta: {
      title: 'Produit - Kingrecharges Store',
    }
  },
];

export default routes;
